import { render, staticRenderFns } from "./equipmentSafety.vue?vue&type=template&id=f27770f2&scoped=true&"
import script from "./equipmentSafety.vue?vue&type=script&lang=js&"
export * from "./equipmentSafety.vue?vue&type=script&lang=js&"
import style0 from "./equipmentSafety.vue?vue&type=style&index=0&id=f27770f2&prod&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f27770f2",
  null
  
)

export default component.exports